import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNewOrleansStructuredData() {
  const url = "https://restorehair.com/locations/louisiana/new-orleans/";
  const description =
    "Find out about your hair transplant options in New Orleans with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("new-orleans", url, description),
    locationPageCrumbs(url, "New Orleans"),
  ];
}
